import axios from 'axios';
import { urlLogActivity } from '../config';


export const fetchData = (url, mapData, setData, setError, token, setExtraData) => {
  fetch(url, {headers: {'Authorization': `Bearer ${token}`}})
    .then(resp => resp.json())
    .then(data => {
      const rowData = mapData ? data.map(mapData) : data;
      setData(rowData);
      if (typeof setExtraData === 'function') setExtraData(rowData.length);
    })
    .catch(error => {
      console.error('Błąd pobierania danych:', error);
      if (typeof setError === 'function') setError(error);
    });
};

export const fetchDataPromise = async (url, mapData, setData, setError, token, setExtraData) => {
  try {
    const resp = await fetch(url, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await resp.json();
    const rowData = mapData ? data.map(mapData) : data;

    if (typeof setData === 'function') setData(rowData);
    if (typeof setExtraData === 'function') setExtraData(rowData.length);

    return rowData;
  } catch (error) {
    console.error('Błąd pobierania danych:', error);
    if (typeof setError === 'function') setError(error);
    throw error; // Rzuć błąd, aby można było go złapać w `await`
  }
};

export const logActivity = async (action, userName, token, contactId = null, month = null, year = null, isEdited = false) => {
  try {
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };
    await axios.post(urlLogActivity + "/log", {
      action: action,
      userName: userName,
      contactId: contactId,
      month: month,
      year: year,
      isEdited: isEdited
    }, config);
  } catch (error) {
    console.error('Błąd podczas rejestrowania aktywności:', error);
  }
};